<template>
  <div class="qr-code-container" v-drag>
    <div class="qr-content">
      <div class="qr-header">
        <el-icon class="icon"><Promotion /></el-icon>
        <span class="text">扫码体验小程序</span>
      </div>
      <img src="@/assets/qr-codes/mini.jpg" alt="小程序二维码" class="qr-image">
      <p class="qr-desc">扫一扫，立即体验</p>
    </div>
  </div>
</template>

<script setup>
import { Promotion } from '@element-plus/icons-vue'

// 拖拽指令
const vDrag = {
  mounted(el) {
    el.style.position = 'fixed'
    el.style.cursor = 'move'
    el.style.zIndex = '999'

    el.onmousedown = (e) => {
      const disX = e.clientX - el.offsetLeft
      const disY = e.clientY - el.offsetTop
      
      document.onmousemove = (e) => {
        let left = e.clientX - disX
        let top = e.clientY - disY
        
        // 防止拖出屏幕
        const maxX = document.documentElement.clientWidth - el.offsetWidth
        const maxY = document.documentElement.clientHeight - el.offsetHeight
        
        left = Math.min(maxX, Math.max(0, left))
        top = Math.min(maxY, Math.max(0, top))
        
        el.style.left = left + 'px'
        el.style.top = top + 'px'
      }
      
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style scoped>
.qr-code-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 8px;
  width: 140px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(147, 112, 219, 0.2);
  transition: all 0.3s ease;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  color: #483D8B;
}

.qr-header .icon {
  font-size: 14px;
  margin-right: 4px;
  color: #9370DB;
}

.qr-header .text {
  font-size: 12px;
  font-weight: 500;
}

.qr-image {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 6px;
  border-radius: 4px;
  border: 1px solid rgba(147, 112, 219, 0.1);
}

.qr-desc {
  color: #606266;
  font-size: 11px;
  margin: 0;
}
</style>